export default "__VITE_ASSET__DCCQLM5E__"